const INTERVIEW_TYPES = {
  INTAKE: "Intake",
  FOLLOW_UP: "FollowUp",
  DISCHARGE: "Discharge",
}
const INTERVIEW_SECTIONS = {
  RECORD_MGMT: "recordManagement",
  START_INTERVIEW: "startInterview",
  DEMOGRAPHICS: "demographics",
  SUBSTANCE_USE_1: "substanceUse1",
  SUBSTANCE_USE_2: "substanceUse2",
  SUBSTANCE_USE_3: "substanceUse3",
  PLANNED_SERVICES_1: "plannedServices1",
  PLANNED_SERVICES_2: "plannedServices2",
  PLANNED_SERVICES_3: "plannedServices3",
  PLANNED_SERVICES_4: "plannedServices4",
  FAMILY: "family",
  EDUCATION: "education",
  LEGAL: "legal",
  MENTAL: "mental",
  SOCIAL: "social",
  PROGRAM: "program",
  FOLLOW_UP: "followUp",
  DISCHARGE: "discharge",
  SERVICES_RECEIVED_1: "servicesReceived1",
  SERVICES_RECEIVED_2: "servicesReceived2",
  SERVICES_RECEIVED_3: "servicesReceived3",
  SERVICES_RECEIVED_4: "servicesReceived4",
  SERVICES_RECEIVED_5: "servicesReceived5",
}
const INTERVIEW_SECTIONS_INTAKE = [
  {
    title: "recordManagement",
    alias: "recordMgmt",
    number: 1,
    fields: ["gpra_participant_id", "gpra_client_type", "gpra_interview_date"],
  },
  {
    title: "demographics",
    number: 2,
    fields: [
      "gpra_a_demo_q1",
      "gpra_a_demo_q2",
      "gpra_a_demo_q3",
      "gpra_a_demo_q4",
      "gpra_a_demo_q5",
      "gpra_a_demo_q6",
      "gpra_a_demo_q7",
      "gpra_a_demo_q8",
      "gpra_a_demo_q9",
      "gpra_a_demo_q10",
      "gpra_a_demo_q11",
    ],
  },
  {
    title: "substanceUse1",
    number: 3,
    fields: [
      "gpra_b_1a1_days",
      "gpra_b_1b1_days",
      "gpra_b_1c1_days",
      "gpra_b_1d1_days",
      "gpra_b_1e1_days",
      "gpra_b_1f1_days",
      "gpra_b_1g1_days",
      "gpra_b_1h1_days",
      "gpra_b_1i1_days",
      "gpra_b_1j1_days",
    ],
  },
  {
    title: "substanceUse2",
    number: 4,
    fields: ["gpra_b_2", "gpra_b_3", "gpra_b_4", "gpra_b_5"],
  },
  {
    title: "substanceUse3",
    number: 5,
    fields: [
      "gpra_b_6",
      "gpra_b_7",
      "gpra_b_8",
      "gpra_b_9",
      "gpra_b_10",
      "gpra_b_11",
    ],
  },
  { title: "plannedServices1", number: 6, fields: ["gpra_b_services_mod_1"] },
  { title: "plannedServices2", number: 7, fields: ["gpra_b_services_ts_1"] },
  {
    title: "plannedServices3",
    number: 8,
    fields: [
      "gpra_b_services_cm_1",
      "gpra_b_services_ms_1",
      "gpra_b_services_acs_1",
    ],
  },
  {
    title: "plannedServices4",
    number: 9,
    fields: ["gpra_b_services_p2p_1", "gpra_b_services_es_1"],
  },
  { title: "family", number: 10, fields: ["gpra_c_1", "gpra_c_2"] },
  {
    title: "education",
    number: 11,
    fields: ["gpra_d_1", "gpra_d_2", "gpra_d_3", "gpra_d_4", "gpra_d_5"],
  },
  {
    title: "legal",
    number: 12,
    fields: ["gpra_e_1", "gpra_e_2", "gpra_e_3", "gpra_e_4"],
  },
  {
    title: "mental",
    number: 13,
    fields: ["gpra_f_1", "gpra_f_2", "gpra_f_3", "gpra_f_4", "gpra_f_5"],
  },
  {
    title: "social",
    number: 14,
    fields: ["gpra_g_1", "gpra_g_2", "gpra_g_3", "gpra_g_4"],
  },
  {
    title: "summary",
    number: 15,
    fields: [],
  },
]
const INTERVIEW_SECTIONS_FOLLOWUP = [
  {
    title: "startInterview",
    alias: "start",
    number: 1,
    fields: ["gpra_interview_conducted"],
  },
  {
    title: "substanceUse1",
    number: 2,
    fields: [
      "gpra_b_1a1_days",
      "gpra_b_1b1_days",
      "gpra_b_1c1_days",
      "gpra_b_1d1_days",
      "gpra_b_1e1_days",
      "gpra_b_1f1_days",
      "gpra_b_1g1_days",
      "gpra_b_1h1_days",
      "gpra_b_1i1_days",
      "gpra_b_1j1_days",
    ],
  },
  {
    title: "substanceUse2",
    number: 3,
    fields: ["gpra_b_2", "gpra_b_3", "gpra_b_4", "gpra_b_5"],
  },
  {
    title: "substanceUse3",
    number: 4,
    fields: [
      "gpra_b_6",
      "gpra_b_7",
      "gpra_b_8",
      "gpra_b_9",
      "gpra_b_10",
      "gpra_b_11",
    ],
  },
  { title: "family", number: 5, fields: ["gpra_c_1", "gpra_c_2"] },
  {
    title: "education",
    number: 6,
    fields: ["gpra_d_1", "gpra_d_2", "gpra_d_3", "gpra_d_4", "gpra_d_5"],
  },
  {
    title: "legal",
    number: 7,
    fields: ["gpra_e_1", "gpra_e_2", "gpra_e_3", "gpra_e_4"],
  },
  {
    title: "mental",
    number: 8,
    fields: ["gpra_f_1", "gpra_f_2", "gpra_f_3", "gpra_f_4", "gpra_f_5"],
  },
  {
    title: "social",
    number: 9,
    fields: ["gpra_g_1", "gpra_g_2", "gpra_g_3", "gpra_g_4"],
  },
  {
    title: "program",
    number: 10,
    fields: ["gpra_h_1", "gpra_h_2", "gpra_h_3"],
  },
  {
    title: "followUp",
    number: 11,
    fields: ["gpra_i_1", "gpra_i_2", "gpra_i_3"],
  },
]
const INTERVIEW_SECTIONS_DISCHARGE = [
  {
    title: "startInterview",
    alias: "start",
    number: 1,
    fields: ["gpra_interview_conducted"],
  },
  {
    title: "substanceUse1",
    number: 2,
    fields: [
      "gpra_b_1a1_days",
      "gpra_b_1b1_days",
      "gpra_b_1c1_days",
      "gpra_b_1d1_days",
      "gpra_b_1e1_days",
      "gpra_b_1f1_days",
      "gpra_b_1g1_days",
      "gpra_b_1h1_days",
      "gpra_b_1i1_days",
      "gpra_b_1j1_days",
    ],
  },
  {
    title: "substanceUse2",
    number: 3,
    fields: ["gpra_b_2", "gpra_b_3", "gpra_b_4", "gpra_b_5"],
  },
  {
    title: "substanceUse3",
    number: 4,
    fields: [
      "gpra_b_6",
      "gpra_b_7",
      "gpra_b_8",
      "gpra_b_9",
      "gpra_b_10",
      "gpra_b_11",
    ],
  },
  { title: "family", number: 5, fields: ["gpra_c_1", "gpra_c_2"] },
  {
    title: "education",
    number: 6,
    fields: ["gpra_d_1", "gpra_d_2", "gpra_d_3", "gpra_d_4", "gpra_d_5"],
  },
  {
    title: "legal",
    number: 7,
    fields: ["gpra_e_1", "gpra_e_2", "gpra_e_3", "gpra_e_4"],
  },
  {
    title: "mental",
    number: 8,
    fields: ["gpra_f_1", "gpra_f_2", "gpra_f_3", "gpra_f_4", "gpra_f_5"],
  },
  {
    title: "social",
    number: 9,
    fields: ["gpra_g_1", "gpra_g_2", "gpra_g_3", "gpra_g_4"],
  },
  {
    title: "program",
    number: 10,
    fields: ["gpra_h_1", "gpra_h_2", "gpra_h_3"],
  },
  {
    title: "discharge",
    number: 11,
    fields: ["gpra_j_1", "gpra_j_2", "gpra_j_3"],
  },
  {
    title: "servicesReceived1",
    number: 12,
    fields: ["gpra_k_mod_1"],
  },
  {
    title: "servicesReceived2",
    number: 13,
    fields: ["gpra_k_ts_1"],
  },
  {
    title: "servicesReceived3",
    number: 14,
    fields: ["gpra_k_cm_1", "gpra_k_ms_1", "gpra_k_acs_1"],
  },
  {
    title: "servicesReceived4",
    number: 15,
    fields: ["gpra_k_es_1", "gpra_k_ptp_1"],
  },
  {
    title: "servicesReceived5",
    number: 16,
    fields: [
      "gpra_k_2",
      "gpra_k_3",
      "gpra_k_4",
      "gpra_k_5",
      "gpra_k_6",
      "gpra_k_7",
    ],
  },
]
const SECTIONS = [
  { label: "Record Management", value: "recordManagement" },
  { label: "Start Interview", value: "startInterview" },
  { label: "Demographics", value: "demographics" },
  { label: "Substance Use 1", value: "substanceUse1" },
  { label: "Substance Use 3", value: "substanceUse2" },
  { label: "Substance Use 3", value: "substanceUse3" },
  { label: "Planned Services 1", value: "plannedServices1" },
  { label: "Planned Services 2", value: "plannedServices2" },
  { label: "Planned Services 3", value: "plannedServices3" },
  { label: "Planned Services 4", value: "plannedServices4" },
  { label: "Family", value: "family" },
  { label: "Education", value: "education" },
  { label: "Legal", value: "legal" },
  { label: "Mental", value: "mental" },
  { label: "Social", value: "social" },
  { label: "Program", value: "program" },
  { label: "FollowUp", value: "followUp" },
  { label: "Discharge", value: "discharge" },
  { label: "Services Received 1", value: "servicesReceived1" },
  { label: "Services Received 2", value: "servicesReceived2" },
  { label: "Services Received 3", value: "servicesReceived3" },
  { label: "Services Received 4", value: "servicesReceived4" },
  { label: "Services Received 5", value: "servicesReceived5" },
]
const RELOAD_TYPES = {
  summary: "summary",
  deleteRecord: "deleteRecord",
  createRecord: "createRecord",
}

export {
  INTERVIEW_TYPES,
  INTERVIEW_SECTIONS,
  RELOAD_TYPES,
  INTERVIEW_SECTIONS_INTAKE,
  INTERVIEW_SECTIONS_FOLLOWUP,
  INTERVIEW_SECTIONS_DISCHARGE,
  SECTIONS,
}
